module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idFrmPan",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('popwin', {
    attrs: {
      "ctrl": _vm.ctrlWin
    }
  }), _vm._v(" "), _c('popwin', {
    attrs: {
      "ctrl": _vm.ctrlClr
    }
  }), _vm._v(" "), _c('popwin', {
    attrs: {
      "ctrl": _vm.ctrlThum
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "50px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    ref: "idMediaCha",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_img.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(151);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaBgc",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_bg.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(152);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaLac",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_lace.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(153);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaPho",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_pho.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(158);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaTxt",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_text.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(159);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "50px",
      "height": "2px",
      "margin-top": "8px",
      "background": "#aaaaaa",
      "border-top": "1px solid #bbbbbb",
      "border-bottom": "1px solid #bbbbbb"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaHat",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_hat.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(161);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaHai",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_hair.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(162);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaMsk",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_mask.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(163);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaExp",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_exp.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(164);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaGla",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_gla.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(165);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaBea",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_bea.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(166);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaLip",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_lip.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(167);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaBli",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_bli.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(168);
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaMor",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_more.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(169);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "50px",
      "height": "2px",
      "margin-top": "8px",
      "background": "#aaaaaa",
      "border-top": "1px solid #bbbbbb",
      "border-bottom": "1px solid #bbbbbb"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMediaQrc",
    staticClass: "MediaItem",
    staticStyle: {
      "background": "url(../static/images/media_qr.png)",
      "background-size": "100% 100%"
    },
    on: {
      "click": function($event) {
        return _vm.onNewMediaClick(156);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 0 auto",
      "width": "50px",
      "border": "1px solid #bbbbbb",
      "background": "#aaaaaa",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "height": "50px",
      "border": "2px solid #ffffff"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "height": "30px",
      "line-height": "30px",
      "margin-left": "10px",
      "margin-right": "6px",
      "margin-top": "10px",
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.templaItem.tmName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "30px",
      "line-height": "30px",
      "margin-left": "10px",
      "margin-right": "6px",
      "margin-top": "10px",
      "color": "#ffffff",
      "border-left": "1px solid #ffffff",
      "text-indent": "10px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("模板名称")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templaItem.templateName),
      expression: "templaItem.templateName"
    }],
    staticStyle: {
      "float": "left",
      "width": "200px",
      "height": "30px",
      "margin-top": "6px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.templaItem.templateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.templaItem, "templateName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "30px",
      "line-height": "30px",
      "margin-left": "16px",
      "margin-right": "6px",
      "margin-top": "10px",
      "color": "#ffffff",
      "border-left": "1px solid #ffffff",
      "text-indent": "10px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("照片规格")))]), _vm._v(" "), _c('cselect', {
    staticStyle: {
      "float": "left",
      "position": "relative",
      "z-index": "999",
      "height": "36px",
      "min-width": "140px",
      "margin-top": "6px"
    },
    attrs: {
      "defv": _vm.curResov,
      "ctrl": _vm.ctrlResov,
      "csData": _vm.dataResov
    },
    model: {
      value: (_vm.curResov),
      callback: function($$v) {
        _vm.curResov = $$v
      },
      expression: "curResov"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "30px",
      "line-height": "30px",
      "margin-left": "16px",
      "margin-right": "6px",
      "margin-top": "10px",
      "color": "#ffffff",
      "border-left": "1px solid #ffffff",
      "text-indent": "10px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("背景色")))]), _vm._v(" "), _c('div', {
    ref: "idBGClr",
    staticStyle: {
      "float": "left",
      "width": "50px",
      "height": "28px",
      "margin-left": "0px",
      "margin-top": "10px",
      "cursor": "pointer",
      "border": "1px solid #ffffff"
    },
    on: {
      "click": _vm.onBGSetClick
    }
  }), _vm._v(" "), ((_vm.templaItem.templatePublish == 180) && (_vm.templaItem.templateCustId == _vm.login.custId)) ? _c('div', {
    ref: "idBtnSave",
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "height": "32px",
      "margin-top": "8px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.onTemplaSaveClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("保存")))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "idEditPan1",
    staticStyle: {
      "flex": "1 0 auto",
      "height": "50px",
      "border": "2px solid #ffffff"
    },
    on: {
      "mouseup": _vm.area_onmouseup,
      "mousemove": _vm.area_onmousemove
    }
  }, [_c('div', {
    ref: "idEditPan2",
    staticStyle: {
      "float": "left",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "idScreenPan",
    staticStyle: {
      "position": "relative",
      "float": "left",
      "background": "#ffffff",
      "border": "0px solid red"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idTempSepa",
    staticStyle: {
      "position": "absolute",
      "background": "#ff0000"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "300px",
      "height": "100%",
      "border": "0px solid red",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "10px",
      "border": "0px solid red"
    }
  }, [_c('img', {
    ref: "idPhotoImg",
    staticStyle: {
      "width": "200px",
      "height": "200px",
      "border": "1px solid #bbbbbb",
      "margin-left": "50px"
    },
    on: {
      "click": _vm._click_snap
    }
  }), _vm._v(" "), (this.templaItem.templateId && this.templaItem.templatePublish == 180) ? _c('div', {
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "border": "0px solid red",
      "float": "right",
      "margin-right": "6px",
      "background": "url(/static/images/op_thum_a.png)",
      "background-size": "100% 100%",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onThumClick
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "margin-top": "20px",
      "margin-left": "10px",
      "border": "0px solid red",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('radio', {
    ref: "idIDFlag0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpIDFlag',
      "val": 0,
      "capt": _vm.getLangText('非证件照')
    },
    model: {
      value: (_vm.templaItem.IDFlag),
      callback: function($$v) {
        _vm.$set(_vm.templaItem, "IDFlag", $$v)
      },
      expression: "templaItem.IDFlag"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idIDFlag1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpIDFlag',
      "val": 1,
      "capt": _vm.getLangText('证件照')
    },
    model: {
      value: (_vm.templaItem.IDFlag),
      callback: function($$v) {
        _vm.$set(_vm.templaItem, "IDFlag", $$v)
      },
      expression: "templaItem.IDFlag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "margin-top": "20px",
      "margin-left": "10px",
      "border": "0px solid red",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('radio', {
    ref: "idSepa0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpSepa',
      "val": 0,
      "capt": _vm.getLangText('不切分'),
      "myClick": _vm.onSepaClick
    },
    model: {
      value: (_vm.templaItem.sepa),
      callback: function($$v) {
        _vm.$set(_vm.templaItem, "sepa", $$v)
      },
      expression: "templaItem.sepa"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idSepa1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpSepa',
      "val": 1,
      "capt": _vm.getLangText('切分'),
      "myClick": _vm.onSepaClick
    },
    model: {
      value: (_vm.templaItem.sepa),
      callback: function($$v) {
        _vm.$set(_vm.templaItem, "sepa", $$v)
      },
      expression: "templaItem.sepa"
    }
  })], 1), _vm._v(" "), _c('div', {
    key: _vm.FlushKey1,
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "20px",
      "margin-top": "16px",
      "margin-left": "10px",
      "text-align": "right",
      "padding-right": "6px"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('CInpInt', {
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-top": "10px"
    },
    attrs: {
      "maxln": 4,
      "def": _vm.curArea.left,
      "change": _vm.onLeftChange,
      "lab": 'L41'
    },
    model: {
      value: (_vm.curArea.left),
      callback: function($$v) {
        _vm.$set(_vm.curArea, "left", $$v)
      },
      expression: "curArea.left"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "20px",
      "margin-top": "16px",
      "margin-left": "50px",
      "text-align": "right",
      "padding-right": "6px"
    }
  }, [_vm._v("Y")]), _vm._v(" "), _c('CInpInt', {
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-top": "10px"
    },
    attrs: {
      "maxln": 4,
      "def": _vm.curArea.top,
      "change": _vm.onTopChange,
      "lab": 'L42'
    },
    model: {
      value: (_vm.curArea.top),
      callback: function($$v) {
        _vm.$set(_vm.curArea, "top", $$v)
      },
      expression: "curArea.top"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "20px",
      "margin-top": "16px",
      "margin-left": "10px",
      "text-align": "right",
      "padding-right": "6px"
    }
  }, [_vm._v("W")]), _vm._v(" "), _c('CInpInt', {
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-top": "10px"
    },
    attrs: {
      "maxln": 4,
      "def": _vm.curArea.width,
      "change": _vm.onWidthChange,
      "lab": 'L31'
    },
    model: {
      value: (_vm.curArea.width),
      callback: function($$v) {
        _vm.$set(_vm.curArea, "width", $$v)
      },
      expression: "curArea.width"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "20px",
      "margin-top": "16px",
      "margin-left": "50px",
      "text-align": "right",
      "padding-right": "6px"
    }
  }, [_vm._v("H")]), _vm._v(" "), _c('CInpInt', {
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-top": "10px"
    },
    attrs: {
      "maxln": 4,
      "def": _vm.curArea.height,
      "change": _vm.onHeightChange,
      "lab": 'L32'
    },
    model: {
      value: (_vm.curArea.height),
      callback: function($$v) {
        _vm.$set(_vm.curArea, "height", $$v)
      },
      expression: "curArea.height"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "16px",
      "margin-left": "10px",
      "text-align": "right",
      "padding-right": "6px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("旋转")))]), _vm._v(" "), _c('CInpInt', {
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-top": "10px"
    },
    attrs: {
      "maxln": 4,
      "minv": -180,
      "maxv": 180,
      "def": _vm.curArea.rotate,
      "change": _vm.onRotateChange,
      "lab": 'L2'
    },
    model: {
      value: (_vm.curArea.rotate),
      callback: function($$v) {
        _vm.$set(_vm.curArea, "rotate", $$v)
      },
      expression: "curArea.rotate"
    }
  })], 1), _vm._v(" "), ((_vm.curArea.ty1 != 159) && (_vm.curArea.ty1 != 158) && (_vm.curArea.ty1 != 156) && (0 < _vm.curArea.areaNo)) ? _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "80px"
    },
    on: {
      "click": _vm.onSourceSetClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("选择素材")))])]) : _vm._e()]), _vm._v(" "), ((_vm.curArea.ty1 == 159) && (0 < _vm.curArea.areaNo)) ? _c('div', {
    key: _vm.FlushKey6
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "120px",
      "margin-top": "6px",
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("字体")))]), _vm._v(" "), _c('cselect', {
    staticStyle: {
      "float": "left",
      "position": "relative",
      "height": "30px",
      "min-width": "150px",
      "z-index": "999"
    },
    attrs: {
      "onchange": _vm.onFontFamilyChange,
      "defv": _vm.curArea.text.family,
      "ctrl": _vm.ctrlFonts,
      "csData": _vm.dataFonts
    },
    model: {
      value: (_vm.curArea.text.family),
      callback: function($$v) {
        _vm.$set(_vm.curArea.text, "family", $$v)
      },
      expression: "curArea.text.family"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "6px",
      "margin-left": "10px",
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("字号")))]), _vm._v(" "), _c('CInpInt', {
    staticStyle: {
      "float": "left",
      "width": "70px",
      "height": "30px",
      "margin-top": "0px"
    },
    attrs: {
      "maxln": 3,
      "minv": 8,
      "maxv": 200,
      "def": _vm.curArea.text.size,
      "change": _vm.onFontSizeChange,
      "lab": 'L1'
    },
    model: {
      value: (_vm.curArea.text.size),
      callback: function($$v) {
        _vm.$set(_vm.curArea.text, "size", $$v)
      },
      expression: "curArea.text.size"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("颜色")))]), _vm._v(" "), _c('div', {
    ref: "idTxtClr",
    staticStyle: {
      "float": "left",
      "width": "50px",
      "height": "28px",
      "margin-left": "0px",
      "cursor": "pointer",
      "border": "1px solid #bbbbbb"
    },
    style: ({
      'background': _vm.curArea.text.color
    }),
    on: {
      "click": _vm.onTxtClrSetClick
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "float": "left",
      "width": "100%",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "margin-right": "6px",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("文本")))]), _vm._v(" "), _c('textarea', {
    ref: "idAreaText",
    staticStyle: {
      "width": "270px",
      "height": "100px",
      "margin-left": "10px"
    },
    attrs: {
      "areaNo": _vm.curArea.areaNo
    },
    on: {
      "change": _vm.onTextChange,
      "focus": function($event) {
        return _vm.setInputLab('L6', 1);
      },
      "blur": function($event) {
        return _vm.setInputLab('L6', 0);
      }
    }
  }, [_vm._v(_vm._s(_vm.curArea.text.cont))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 0 auto",
      "float": "left",
      "width": "100%",
      "border": "0px solid green",
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid blue"
    }
  }, [_c('table', {
    ref: "idMedialList",
    staticStyle: {
      "width": "100%",
      "font-size": "14px"
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37393f1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/TemplaEdit.vue
// module id = 777
// module chunks = 1